export const INVOICE_STATUS_FR = {
  draft: "Brouillon", issued: "Émise", sent: "Envoyée", paid: "Payée",
  partially_paid: "Part. payée", overdue: "En retard", cancelled: "Annulée",
  void: "Annulée", imported: "Importée", pending: "En attente",
  pending_validation: "À valider", to_validate: "À valider", validated: "Validée",
  rejected: "Rejetée", to_pay: "À payer", scheduled: "Programmée",
};

export const invoiceStatusFr = (s) => (s ? INVOICE_STATUS_FR[s] || s : "—");
